import React, { useEffect, useRef, useState } from 'react'
import { Loader } from '@googlemaps/js-api-loader'
import PropTypes from 'prop-types'
import { CloseIcon } from '@pga/pga-component-library'
import { InputContainer, ClearWrapper, StyledInput, InputWrapper } from './styled'

import './google-places-override.css'

export const elementId = 'location-zipcode'

export const isUSState = types => types.includes('administrative_area_level_1')

const isSearchStateOrPlace = (searchStateChange, types, { name, lat, lng }) => {
  if (isUSState(types)) {
    searchStateChange({
      type: 'state',
      value: name
    })
  } else {
    searchStateChange({
      type: 'places',
      value: name,
      lat,
      lng
    })
  }
}

export const isSearchPageOrHomePage = (onSearchStateChange, onLocationStateChange, types, name, lat, lng) => {
  if (onSearchStateChange) {
    return isSearchStateOrPlace(onSearchStateChange, types, { name, lat, lng })
  } else {
    return isSearchStateOrPlace(onLocationStateChange, types, { name, lat, lng })
  }
}

const apiLoader = new Loader({
  apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  version: 'weekly',
  libraries: ['places']
})

const handleAPILoad = (onSearchStateChange, onLocationStateChange, autoCompleteRef) => {
  apiLoader.load().then(() => {
    getApiLoader(autoCompleteRef, onSearchStateChange, onLocationStateChange)
  })
}

export const getApiLoader = (autoCompleteRef, onSearchStateChange, onLocationStateChange) => {
  const placesAutoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    {
      types: ['(regions)'],
      componentRestrictions: { country: 'us' }
    }
  )
  placesAutoComplete.setFields(['geometry', 'name', 'types'])
  placesAutoComplete.addListener('place_changed', () =>
    handleSelection(onSearchStateChange, onLocationStateChange, placesAutoComplete)
  )
}

export const handleSelection = (onSearchStateChange, onLocationStateChange, placesAutoComplete) => {
  const place = placesAutoComplete.getPlace()
  if (place) {
    const { types, geometry, name } = place
    if (geometry) {
      const geo = geometry.location.toJSON()
      const { lat, lng } = geo
      return isSearchPageOrHomePage(onSearchStateChange, onLocationStateChange, types, name, lat, lng)
    }
  }
}

const PlacesLocationInput = ({ placeholder, id, onChange, defaultValue, onClear, onLocationStateChange }) => {
  const [locationValue, setLocationValue] = useState('')
  const autoCompleteRef = useRef(null)

  const handleClear = () => {
    const locationInput = document.getElementById(elementId)
    if (locationInput) locationInput.value = ''
    setLocationValue(onClear)
  }

  useEffect(() => {
    const loadAPI = async () => {
      handleAPILoad(onChange, onLocationStateChange, autoCompleteRef)
    }
    loadAPI()
  }, [])

  return (
    <InputContainer>
      <InputWrapper>
        <StyledInput
          type='text'
          className='form-control'
          placeholder={placeholder}
          id={id}
          onChange={(event) => setLocationValue(event.target.value)}
          ref={autoCompleteRef}
          defaultValue={defaultValue}
        />
        <ClearWrapper onClick={handleClear}>{locationValue && (<CloseIcon />)}</ClearWrapper>
      </InputWrapper>
    </InputContainer>
  )
}

PlacesLocationInput.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  onLocationStateChange: PropTypes.func
}

export const defaultPlacesConfig = {
  placeholder: 'City, State, or Zip Code',
  id: 'location-zipcode'
}

export default PlacesLocationInput
